export default __webpack_public_path__ + "static/media/1-5.3c987c9a.png";